import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { useQuery } from "react-query";

interface BankStatementSearchDetails {
  Page: number;
  PageSize: number;
  DateFrom?: string | null;
  DateTo?: string | null;
  CustomerId: number;
}

const getCustomerBankDetails = async ({
  Page,
  PageSize,
  DateFrom,
  DateTo,
  CustomerId,
}: BankStatementSearchDetails) => {
  let queryParams = `?customer_id=${CustomerId}&page=${Page}&page_size=${PageSize}`;
  if (DateFrom) {
    queryParams = `${queryParams}&from_date=${DateFrom}`;
  }
  if (DateTo) {
    queryParams = `${queryParams}&to_date=${DateTo}`;
  }

  const data = await getData(
    `${ajaxEndpoints.BANK_STATEMENT_DATA_OF_CUSTOMER}${queryParams}`
  );
  return data?.data;
};

export const useCustomerBankDetails = ({
  Page,
  PageSize,
  DateFrom,
  DateTo,
  CustomerId,
}: BankStatementSearchDetails) => {
  return useQuery(
    [
      { Page, PageSize, DateFrom, DateTo, CustomerId },
      "getCustomerBankDetails",
    ],
    getCustomerBankDetails,
    {
      refetchOnWindowFocus: false,
      enabled: CustomerId ? true : false,
    }
  );
};
